function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { AlertsBus } from 'modules/App';
import InformationForm from './InformationForm';
var _React_PureComponent;
class Information extends (_React_PureComponent = React.PureComponent) {
    render() {
        const { StepsElement, activeStepIdx } = this.props;
        return /*#__PURE__*/ _jsxs("section", {
            className: "section",
            children: [
                StepsElement,
                /*#__PURE__*/ _jsx(AlertsBus, {
                    className: "mb-6"
                }),
                /*#__PURE__*/ _jsx(InformationForm, {
                    activeStepIdx: this.props.activeStepIdx,
                    onSuccess: (organizationProposal)=>this.props.onChangeView('Summary', organizationProposal),
                    onBack: ()=>activeStepIdx ? this.props.onChangeView('Country') : this.props.onClose()
                })
            ]
        });
    }
}
_define_property(Information, "propTypes", {
    StepsElement: PropTypes.element,
    activeStepIdx: PropTypes.number,
    onChangeView: PropTypes.func,
    onClose: PropTypes.func
});
export default Information;
